import { Loaded } from "./types";

export function isLoaded<T>(loaded: Loaded<T>): loaded is { status: "loaded"; data: T } {
    return loaded.status === "loaded";
}
